// extracted by mini-css-extract-plugin
export var content = "_9s-3";
export var list = "_9s-4";
export var settingsContent = "_9s-7";
export var settingsPanel = "_9s-8";
export var state = "_9s-6";
export var triggerBadge = "_9s-2";
export var triggerButton = "_9s-1";
export var triggerShell = "_9s-0";
export var unreadDot = "_9s-5";